import { render, staticRenderFns } from "./InformacoesDadosSevComponent.vue?vue&type=template&id=7b654a73"
import script from "./InformacoesDadosSevComponent.vue?vue&type=script&lang=js"
export * from "./InformacoesDadosSevComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports